import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExpressionOperator } from 'src/app/model/search-filters/expression-operator';
import { Filter } from 'src/app/model/search-filters/filter';
import { SearchFilterItem } from 'src/app/model/search-filters/search-filter-item';
import { SearchFilterLanguageType } from 'src/app/model/search-filters/search-filter-language';
import { SearchFilterType } from 'src/app/model/search-filters/search-filter-type';

@Component({
  selector: 'gymfinder-search-filter-item',
  templateUrl: './search-filter-item.component.html',
  styleUrls: ['./search-filter-item.component.scss'],
  standalone: false,
})
export class SearchFilterItemComponent implements OnInit {
  @Input()
  item: SearchFilterItem;

  @Output()
  itemChange = new EventEmitter<SearchFilterItem>();

  @Output()
  itemRemove = new EventEmitter<void>();

  @Input()
  availableFilters: Filter[];

  _type?: SearchFilterType;

  _childrenLogic?: ExpressionOperator;

  _peerLogic?: ExpressionOperator;

  _text: SearchFilterLanguageType;

  _alwaysActive?: boolean;

  _visible?: boolean;

  _filters?: Filter[];

  filterTypes = Object.values(SearchFilterType);

  expressionOperators = Object.values(ExpressionOperator);

  ngOnInit(): void {
    this._type = this.item.type;
    this._childrenLogic = this.item.childrenLogic;
    this._peerLogic = this.item.peerLogic;
    this._text = this.item.text || {};
    this._alwaysActive = this.item.alwaysActive;
    this._visible = this.item.visible;
    this._filters = this.item.filters;
  }

  get type(): SearchFilterType | undefined {
    return this._type;
  }

  set type(newValue: SearchFilterType | undefined) {
    this._type = newValue;
    this.item.type = newValue;
    this.itemChange.emit(this.item);
  }

  get childrenLogic(): ExpressionOperator | undefined {
    return this._childrenLogic;
  }

  set childrenLogic(newValue: ExpressionOperator | undefined) {
    this._childrenLogic = newValue;
    this.item.childrenLogic = newValue;
    this.itemChange.emit(this.item);
  }

  get peerLogic(): ExpressionOperator | undefined {
    return this._peerLogic;
  }

  set peerLogic(newValue: ExpressionOperator | undefined) {
    this._peerLogic = newValue;
    this.item.peerLogic = newValue;
    this.itemChange.emit(this.item);
  }

  get text(): SearchFilterLanguageType {
    return this._text;
  }

  set text(newValue: SearchFilterLanguageType) {
    this._text = newValue;
    this.item.text = newValue;
    this.itemChange.emit(this.item);
  }

  get alwaysActive(): boolean | undefined {
    return this._alwaysActive;
  }

  set alwaysActive(newValue: boolean | undefined) {
    this._alwaysActive = newValue;
    this.item.alwaysActive = newValue;
    this.itemChange.emit(this.item);
  }

  get visible(): boolean | undefined {
    return this._visible;
  }

  set visible(newValue: boolean | undefined) {
    this._visible = newValue;
    this.item.visible = newValue;
    this.itemChange.emit(this.item);
  }

  get filters(): Filter[] | undefined {
    return this._filters;
  }

  set filters(newValue: Filter[] | undefined) {
    this._filters = newValue;
    this.item.filters = newValue;
    this.itemChange.emit(this.item);
  }

  public handleItemRemove() {
    this.itemRemove.emit();
  }
}
